var t = Object.defineProperty;
var o = (e, i, a) => i in e ? t(e, i, { enumerable: !0, configurable: !0, writable: !0, value: a }) : e[i] = a;
var s = (e, i, a) => o(e, typeof i != "symbol" ? i + "" : i, a);
var d = /* @__PURE__ */ ((e) => (e.FailedToFetchOIDCConfiguration = "FailedToFetchOIDCConfiguration", e.AuthenticationRequestFailed = "AuthenticationRequestFailed", e.AccessTokenRequestFailed = "AccessTokenRequestFailed", e.LegacyTokenRequestFailed = "LegacyTokenRequestFailed", e.RevokeTokenRequestFailed = "RevokeTokenRequestFailed", e.UserManagerCreationFailed = "UserManagerCreationFailed", e.OneTimeCodeMissing = "OneTimeCodeMissing", e.FailedToRemoveSession = "FailedToRemoveSession", e))(d || {});
class l extends Error {
  constructor(a, n) {
    super(n);
    s(this, "type");
    this.name = a, this.type = a;
  }
}
export {
  l as OIDCError,
  d as OIDCErrorType
};
